import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import BreakingTicker from "@/components/feature/BreakingTicker";
import FaqSection from "@/components/feature/FaqSection";
import HomeIntro from "@/pages/home/components/HomeIntro";
import FocusSection from "@/pages/home/components/FocusSection";
import TrackFlowSection from "@/pages/home/components/TrackFlowSection";
import TimelineFeature from "@/pages/home/components/TimelineFeature";
import CategorySection from "@/pages/home/components/CategorySection";
import PrincipleGrid from "@/components/feature/PrincipleGrid";
import CtaBand from "@/pages/home/components/CtaBand";
import { stories } from "@/mocks/stories";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";

const ORIGIN = "https://laisih.cn";

export default function Home() {
  const lead = stories.find((story) => story.featured) ?? stories[0];
  const ranking = [...stories].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const feed = stories.filter((story) => story.id !== lead.id).slice(0, 5);
  const reversals = stories.filter((story) => story.status === "已反转").slice(0, 3);
  const timelineStory = stories.find((story) => story.id === "yinyuejie-jianqu") ?? stories[1];

  const tagPool: string[] = [];
  stories.forEach((story) => {
    story.tags.forEach((tag) => {
      if (!tagPool.includes(tag)) tagPool.push(tag);
    });
  });
  const tags = tagPool.slice(0, 14);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      alternateName: siteInfo.nameEn,
      url: ORIGIN,
      inLanguage: "zh-CN",
      description: siteInfo.description,
      potentialAction: {
        "@type": "SearchAction",
        target: `${ORIGIN}/news?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "黑瓜爆料编辑部",
      alternateName: siteInfo.name,
      url: ORIGIN,
      email: siteInfo.email,
      description: siteInfo.description,
      foundingDate: siteInfo.since,
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "黑瓜爆料重点追踪事件",
      itemListElement: stories.slice(0, 6).map((story, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: story.title,
        url: `${ORIGIN}/news/${story.id}`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="黑瓜爆料｜娱乐事件持续追踪，跟进回应、反转与最新进展"
        description="黑瓜爆料持续追踪每一条娱乐线索，跟进当事人回应、反转节点与最新进展。用一条时间线看懂事件从首次流出到最终收束的完整过程，不错过每一步变化。"
        keywords="黑瓜爆料,爆料后续,爆料反转,最新进展,当事人回应,事件追踪"
        path="/"
        jsonLd={jsonLd}
      />
      <BreakingTicker />
      <HomeIntro />
      <FocusSection lead={lead} ranking={ranking} />
      <TrackFlowSection feed={feed} reversals={reversals} tags={tags} />
      <TimelineFeature story={timelineStory} />
      <CategorySection />
      <PrincipleGrid />
      <FaqSection />
      <CtaBand />
    </SiteLayout>
  );
}